import React from 'react'
import { Container } from '@sainsburys-tech/fable'

const RAMSItems = [
  'You have been signed out of site as you couldn\'t confirm RAMS were in place',
  'Do not start any work which doesn\'t have RAMS'
]

const RAMSDeclinePolicy = () => (
  <Container>
    <h3 className="dsib-policyWording__title">Declined RAMS </h3>
    <ul className="dsib-policyWording__list">
      {RAMSItems.map((item, index) => (
        <li key={index} className="dsib-policyWording__listItem">{item}</li>
      ))}
    </ul>
  </Container>
)

export default RAMSDeclinePolicy
